// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-list[data-v-7218dcc5]{overflow-x:hidden;overflow-y:auto;padding-top:1rem}.message-agent[data-v-7218dcc5],.message-bot[data-v-7218dcc5]{align-self:flex-start}.message-feedback[data-v-7218dcc5],.message-human[data-v-7218dcc5]{align-self:flex-end}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
